import React from 'react'

const Backend = () => {
  return (
    <div className="skills__content">
    <h3 className="skills__title">Desenvolvimento Backend</h3>

    <div className="skills__box">
        <div className="skills__group">
        <div className="skills__data">
        <i class='bx bx-badge-check' ></i>

        <div>
            <h3 className="skills__name">PHP</h3>
            <span className="skills__level">Avançado</span>
        </div>
        </div>

        <div className="skills__data">
        <i class='bx bx-badge-check' ></i>

        <div>
            <h3 className="skills__name">VB.NET</h3>
            <span className="skills__level">Avançado</span>
        </div>
        </div>

        <div className="skills__data">
        <i class='bx bx-badge-check' ></i>

        <div>
            <h3 className="skills__name">Python</h3>
            <span className="skills__level">Intermediário</span>
        </div>
        </div>

        <div className="skills__data">
        <i class='bx bx-badge-check' ></i>

        <div>
            <h3 className="skills__name">MySQL</h3>
            <span className="skills__level">Intermediário</span>
        </div>
        </div>
        

        </div>

        <div className="skills__group">
        <div className="skills__data">
        <i class='bx bx-badge-check' ></i>

        <div>
            <h3 className="skills__name">Node JS</h3>
            <span className="skills__level">Intermediário</span>
        </div>
        </div>

        <div className="skills__data">
        <i class='bx bx-badge-check' ></i>

        <div>
            <h3 className="skills__name">Django</h3>
            <span className="skills__level">Intermediário</span>
        </div>
        </div>

        <div className="skills__data">
        <i class='bx bx-badge-check' ></i>

        <div>
            <h3 className="skills__name">Laravel</h3>
            <span className="skills__level">Intermediário</span>
        </div>
        </div>

        <div className="skills__data">
       <i class='bx bx-badge-check' ></i>

        <div>
            <h3 className="skills__name">C#</h3>
            <span className="skills__level">Básico</span>
        </div>
        </div>

        </div>

        
    </div>
</div>
  )
}

export default Backend